import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=33c80db9&lang=pug&"
import script from "./certification.vue?vue&type=script&lang=js&"
export * from "./certification.vue?vue&type=script&lang=js&"
import style0 from "./certification.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports